import { gql, TypedDocumentNode } from "@apollo/client";

import {
  IdentifiersQueryQuery,
  IdentifiersQueryQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { useFetchQuery } from "src/graphql/utils";
import { mapDataTypeToAppDataType } from "src/mappers/typedValue.mappers";
import { ClientSchemaIdentifier } from "src/types/clientSchema";
import { isEmpty } from "src/utils/arrays.utils.ts";

const identifiersQuery = gql(/* GraphQL */ `
  query IdentifiersQuery {
    schema {
      caseTypes {
        code
        elements {
          code
          name
          elementType {
            identifiers {
              code
              name
              identifierType {
                name
                code
              }
              sourceProperties {
                datatype
              }
            }
          }
        }
      }
    }
  }
`) as TypedDocumentNode<IdentifiersQueryQuery, IdentifiersQueryQueryVariables>;

export const useGetIdentifiersQuery = ({
  onError,
  caseTypeCode,
}: {
  onError: (error: Error) => void;
  caseTypeCode?: string;
}) => {
  return useFetchQuery(identifiersQuery, {
    toData: (data) =>
      data?.schema?.caseTypes
        ?.filter((caseType) => !caseTypeCode || caseType.code === caseTypeCode)
        ?.flatMap((caseType) =>
          caseType.elements.flatMap((caseTypeElement) =>
            caseTypeElement.elementType.identifiers.map(
              (identifier) =>
                ({
                  elementCode: caseTypeElement.code,
                  elementName: caseTypeElement.name,
                  identifierCode: identifier.code,
                  identifierTypeCode: identifier.identifierType.code,
                  identifierName: identifier.name,
                  dataType: mapDataTypeToAppDataType(identifier.sourceProperties[0].datatype),
                } satisfies ClientSchemaIdentifier)
            )
          )
        ) ?? [],
    isEmpty: (data) => isEmpty(data?.schema?.caseTypes),
    queryOptions: {
      onError,
    },
    uiErrors: {
      fetchError: "FETCH-IDENTIFIER-TYPES-ERROR",
      emptyError: "EMPTY-IDENTIFIER-TYPES-ERROR",
    },
  });
};
